"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-six/sections/aboutusSection.tsx */

import { SmartImage } from "@/Components";
import Lightbox, { type LightboxSlide } from "../../Components/Lightbox";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, ReactNode } from "react";

export type HomeSixAboutusSectionGeneratedProps = {
    activeIndex?: number;
    lightboxSlides?: LightboxSlide[];
    lightboxOpen?: boolean;
    lightboxIndex?: number;
    onLightboxClose?: () => void;
    onLightboxView?: (index: number) => void;
    onOpenLightbox?: (index: number) => void;
    sectionDiv0Div0ClassName?: string;
    /** Default: "Play Video · Play Video ·" */
    sectionDiv0Div0Div0Div0Button0ButtonDataText?: string;
    sectionDiv0Div0Div0Div0Button0ButtonVisible?: boolean;
    sectionDiv0Div0Div0Div0Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Button0ButtonProps?: Partial<ComponentProps<"button">>;
    /** Default: "about" */
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/about-03.jpg" */
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "about" */
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/about-04.png" */
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageSrc?: string;
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "About Us" */
    sectionDiv0Div0Div1Div0Div0Div0DivText?: ReactNode;
    /** Default: "Our Story of" */
    sectionDiv0Div0Div1Div0Div0H20H2Text?: ReactNode;
    /** Default: "Veterinary Care" */
    sectionDiv0Div0Div1Div0Div0H20H2Text2?: ReactNode;
    sectionDiv0Div0Div1Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div1Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Compassionate" */
    sectionDiv0Div0Div1Div0Div0H20Span0SpanText?: ReactNode;
    /** Default: "At Doccure, we are passionate about providing compassionate, high-quality veterinary care for your beloved pets. With a team of experienced veterinarians, technicians, and support staff, we are dedicated to ensuring the health and well being of animals." */
    sectionDiv0Div0Div1Div0Div0P0PText?: ReactNode;
    /** Default: "Our Mission" */
    sectionDiv0Div0Div1Div0Div1Div0H30H3Text?: ReactNode;
    sectionDiv0Div0Div1Div0Div1Div0H30H3Visible?: boolean;
    sectionDiv0Div0Div1Div0Div1Div0H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div1Div0H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "banner-icon" */
    sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/banner-icon-6.png" */
    sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Our mission is to provide exceptional veterinary care through personalized services and advanced treatments. We are dedicated to fostering long-term relationships with pets." */
    sectionDiv0Div0Div1Div0Div1Div0P0PText?: ReactNode;
    /** Default: "Our Vision" */
    sectionDiv0Div0Div1Div0Div1Div1H30H3Text?: ReactNode;
    sectionDiv0Div0Div1Div0Div1Div1H30H3Visible?: boolean;
    sectionDiv0Div0Div1Div0Div1Div1H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div1Div1H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "banner-icon" */
    sectionDiv0Div0Div1Div0Div1Div1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/banner-icon-6.png" */
    sectionDiv0Div0Div1Div0Div1Div1ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div1Div0Div1Div1ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div1Div0Div1Div1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div1Div1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Our mission is to provide exceptional veterinary care through personalized services and advanced treatments. We are dedicated to fostering long-term relationships with pets." */
    sectionDiv0Div0Div1Div0Div1Div1P0PText?: ReactNode;
    /** Default: "about-img" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/about-img-2.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "about-img" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/foot-prints-1.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "about-img" */
    sectionImageWithBasePath2ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/about-icons-1.svg" */
    sectionImageWithBasePath2ImageSrc?: string;
    sectionImageWithBasePath2ImageVisible?: boolean;
    sectionImageWithBasePath2ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
};

const HomeSixAboutusSectionGenerated: FC<HomeSixAboutusSectionGeneratedProps> = ({
    activeIndex,
    lightboxSlides = [],
    lightboxOpen,
    lightboxIndex,
    onLightboxClose,
    onLightboxView,
    onOpenLightbox,
    sectionDiv0Div0Div0Div0Button0ButtonDataText = "Play Video · Play Video ·",
    sectionDiv0Div0Div0Div0Button0ButtonVisible,
    sectionDiv0Div0Div0Div0Button0ButtonRenderer,
    sectionDiv0Div0Div0Div0Button0ButtonProps,
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt = "about",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/about-03.jpg",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageAlt = "about",
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/about/about-04.png",
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageVisible,
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageRenderer,
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageProps,
    sectionDiv0Div0Div1Div0Div0Div0DivText = "About Us",
    sectionDiv0Div0Div1Div0Div0H20H2Text = "Our Story of",
    sectionDiv0Div0Div1Div0Div0H20H2Text2 = "Veterinary Care",
    sectionDiv0Div0Div1Div0Div0H20H2Visible,
    sectionDiv0Div0Div1Div0Div0H20H2Renderer,
    sectionDiv0Div0Div1Div0Div0H20H2Props,
    sectionDiv0Div0Div1Div0Div0H20Span0SpanText = "Compassionate",
    sectionDiv0Div0Div1Div0Div0P0PText = "At Doccure, we are passionate about providing compassionate, high-quality veterinary care for your beloved pets. With a team of experienced veterinarians, technicians, and support staff, we are dedicated to ensuring the health and well being of animals.",
    sectionDiv0Div0Div1Div0Div1Div0H30H3Text = "Our Mission",
    sectionDiv0Div0Div1Div0Div1Div0H30H3Visible,
    sectionDiv0Div0Div1Div0Div1Div0H30H3Renderer,
    sectionDiv0Div0Div1Div0Div1Div0H30H3Props,
    sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageAlt = "banner-icon",
    sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/banner-icon-6.png",
    sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div1Div0Div1Div0P0PText = "Our mission is to provide exceptional veterinary care through personalized services and advanced treatments. We are dedicated to fostering long-term relationships with pets.",
    sectionDiv0Div0Div1Div0Div1Div1H30H3Text = "Our Vision",
    sectionDiv0Div0Div1Div0Div1Div1H30H3Visible,
    sectionDiv0Div0Div1Div0Div1Div1H30H3Renderer,
    sectionDiv0Div0Div1Div0Div1Div1H30H3Props,
    sectionDiv0Div0Div1Div0Div1Div1ImageWithBasePath0ImageAlt = "banner-icon",
    sectionDiv0Div0Div1Div0Div1Div1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/banner-icon-6.png",
    sectionDiv0Div0Div1Div0Div1Div1ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div1Div0Div1Div1ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div1Div0Div1Div1ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div1Div0Div1Div1P0PText = "Our mission is to provide exceptional veterinary care through personalized services and advanced treatments. We are dedicated to fostering long-term relationships with pets.",
    sectionImageWithBasePath0ImageAlt = "about-img",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/about-img-2.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "about-img",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/icons/foot-prints-1.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    sectionImageWithBasePath2ImageAlt = "about-img",
    sectionImageWithBasePath2ImageSrc = "/Templates/Doccure/img/icons/about-icons-1.svg",
    sectionImageWithBasePath2ImageVisible,
    sectionImageWithBasePath2ImageRenderer,
    sectionImageWithBasePath2ImageProps,
    sectionDiv0Div0ClassName,
}) => {
    return (
        <>
            <section className="about-section-six section">
                <div className="container">
                    <div className={sectionDiv0Div0ClassName ?? "row align-items-center"}>
                        <div className="col-lg-6">
                            <div className="about-img-six">
                                {renderNode(sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid img-one" {...(sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                                {renderNode(sectionDiv0Div0Div0Div0ImageWithBasePath1ImageVisible, sectionDiv0Div0Div0Div0ImageWithBasePath1ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div0Div0Div0ImageWithBasePath1ImageSrc} alt={sectionDiv0Div0Div0Div0ImageWithBasePath1ImageAlt} className="img-fluid img-two" {...(sectionDiv0Div0Div0Div0ImageWithBasePath1ImageProps ?? {})} />
                                ))}
                                {renderNode(sectionDiv0Div0Div0Div0Button0ButtonVisible, sectionDiv0Div0Div0Div0Button0ButtonRenderer, (
                                    <button type="button" className="animate-button" data-text={sectionDiv0Div0Div0Div0Button0ButtonDataText} {...(sectionDiv0Div0Div0Div0Button0ButtonProps ?? {})}>
                                        <p className="button-text" />
                                        <span className="button-circle">
                                            <i className="isax isax-play" />
                                        </span>
                                    </button>
                                ))}
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="about-content-six">
                                <div className="section-header section-header-six">
                                    <div className="section-sub-title ms-0">{sectionDiv0Div0Div1Div0Div0Div0DivText}</div>
                                    {renderNode(sectionDiv0Div0Div1Div0Div0H20H2Visible, sectionDiv0Div0Div1Div0Div0H20H2Renderer, (
                                        <h2 className="section-title" {...(sectionDiv0Div0Div1Div0Div0H20H2Props ?? {})}>
                                            {sectionDiv0Div0Div1Div0Div0H20H2Text}
                                            <span className="line-6">{sectionDiv0Div0Div1Div0Div0H20Span0SpanText}</span>
                                            {" "}
                                            {sectionDiv0Div0Div1Div0Div0H20H2Text2}
                                        </h2>
                                    ))}
                                    <p>{sectionDiv0Div0Div1Div0Div0P0PText}</p>
                                </div>
                                <div className="about d-flex align-items-center gap-4">
                                    <div className={activeIndex === 0 ? "about-vision active" : "about-vision"}>
                                        {renderNode(sectionDiv0Div0Div1Div0Div1Div0H30H3Visible, sectionDiv0Div0Div1Div0Div1Div0H30H3Renderer, (
                                            <h3 className="custom-title" {...(sectionDiv0Div0Div1Div0Div1Div0H30H3Props ?? {})}>{sectionDiv0Div0Div1Div0Div1Div0H30H3Text}</h3>
                                        ))}
                                        <p className="para">{sectionDiv0Div0Div1Div0Div1Div0P0PText}</p>
                                        {renderNode(sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageRenderer, (
                                            <SmartImage src={sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageAlt} className="img-fluid icon-one" {...(sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageProps ?? {})} />
                                        ))}
                                    </div>
                                    <div className={activeIndex === 1 ? "about-vision active" : "about-vision"}>
                                        {renderNode(sectionDiv0Div0Div1Div0Div1Div1H30H3Visible, sectionDiv0Div0Div1Div0Div1Div1H30H3Renderer, (
                                            <h3 className="custom-title" {...(sectionDiv0Div0Div1Div0Div1Div1H30H3Props ?? {})}>{sectionDiv0Div0Div1Div0Div1Div1H30H3Text}</h3>
                                        ))}
                                        <p className="para">{sectionDiv0Div0Div1Div0Div1Div1P0PText}</p>
                                        {renderNode(sectionDiv0Div0Div1Div0Div1Div1ImageWithBasePath0ImageVisible, sectionDiv0Div0Div1Div0Div1Div1ImageWithBasePath0ImageRenderer, (
                                            <SmartImage src={sectionDiv0Div0Div1Div0Div1Div1ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div1Div0Div1Div1ImageWithBasePath0ImageAlt} className="img-fluid icon-one" {...(sectionDiv0Div0Div1Div0Div1Div1ImageWithBasePath0ImageProps ?? {})} />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                    <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid element-1" {...(sectionImageWithBasePath0ImageProps ?? {})} />
                ))}
                {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                    <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="img-fluid element-2" {...(sectionImageWithBasePath1ImageProps ?? {})} />
                ))}
                {renderNode(sectionImageWithBasePath2ImageVisible, sectionImageWithBasePath2ImageRenderer, (
                    <SmartImage src={sectionImageWithBasePath2ImageSrc} alt={sectionImageWithBasePath2ImageAlt} className="img-fluid element-3" {...(sectionImageWithBasePath2ImageProps ?? {})} />
                ))}
            </section>
            <Lightbox images={lightboxSlides} currentIndex={lightboxIndex ?? 0} isOpen={lightboxOpen} onClose={() => onLightboxClose?.()} onNavigate={(index) => onLightboxView?.(index)} />
        </>
    );
};

export default HomeSixAboutusSectionGenerated;
